/**
 * PATH: packages/email-hub/src/feature/email-layout/EmailSidebarTop.tsx
 * FILE_ID: EMAIL-LAYOUT-SIDEBAR-TOP-001
 * PURPOSE: Render the primary compose and Kanban actions above Email navigation.
 */

import { KanbanSquare, PenSquare } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { cn } from '../../_internal/lib/utils'
import type { EmailLayoutController } from './useEmailLayoutController'

export function EmailSidebarTop({
  layout,
}: {
  layout: EmailLayoutController
}) {
  return (
    <>
      <div className={cn('p-2', layout.collapsed && 'flex justify-center')}>
        <button
          type="button"
          onClick={layout.openNewCompose}
          className={cn(
            'flex items-center justify-center gap-2 rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors shadow-sm',
            layout.collapsed
              ? 'h-9 w-9 p-0'
              : 'w-full px-3 py-2.5 text-sm',
          )}
          title="Compose"
        >
          <PenSquare className="w-4 h-4 shrink-0" />
          {!layout.collapsed && <span>Compose</span>}
        </button>
      </div>

      <div
        className={cn(
          'px-2 pb-2',
          layout.collapsed && 'flex justify-center',
        )}
      >
        <NavLink
          to="/kanban"
          title={layout.collapsed ? 'Switch to Kanban Board' : undefined}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-2 rounded-lg border transition-colors',
              layout.collapsed
                ? 'h-9 w-9 justify-center p-0'
                : 'w-full px-3 py-2 text-sm font-medium',
              isActive
                ? 'border-primary/40 bg-primary/10 text-primary'
                : 'border-border bg-background hover:border-primary/30 hover:bg-primary/5 text-foreground',
            )
          }
        >
          <KanbanSquare className="w-4 h-4 shrink-0" />
          {!layout.collapsed && <span>Switch to Kanban</span>}
        </NavLink>
      </div>
    </>
  )
}
